var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "h100-vh flex pad20 flex-column bg-f2" },
    [
      _c("div", { staticClass: "f22 mar20-b lh-1 flex-shrink" }, [
        _vm._v("采购对账")
      ]),
      _c(
        "div",
        { staticClass: "flex-auto" },
        [
          _c("n-list-generato", {
            attrs: {
              searchData: _vm.searchData,
              theadData: _vm.theadData,
              tbodyData: _vm.tbodyData,
              total: _vm.total,
              pageSize: _vm.pageSize,
              "current-page": _vm.pageNum,
              "page-sizes": [10, 20, 30, 50, 100],
              buttonFunctionData: _vm.buttonFunctionData
            },
            on: {
              "update:currentPage": function($event) {
                _vm.pageNum = $event
              },
              "update:current-page": function($event) {
                _vm.pageNum = $event
              },
              searchSubmit: _vm.searchSubmit,
              "size-change": _vm.sizeChange,
              "current-change": _vm.currentChange,
              buttonFunctionAdd: _vm.handleAdd,
              buttonFunctionRefresh: _vm.loadData,
              buttonFunctionExport: _vm.handleExport
            },
            scopedSlots: _vm._u([
              {
                key: "fn",
                fn: function(slotProps) {
                  return [
                    _c(
                      "el-link",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.viewPdf(slotProps)
                          }
                        }
                      },
                      [_vm._v("查看")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("GenerateStatement", {
        ref: "generateStatement",
        attrs: { supplierList: _vm.supplierList }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }